import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Slidebar, NavBar, BottomNav, TouristPlanNav} from '../shared';
import {roleBasedUrl} from '../../helpers';

class UserLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sideBarIsVisible: false
		};
	}

	componentDidMount() {}

	toggleSidebar = () => {
		this.setState((prevState, props) => {
			return {sideBarIsVisible: !prevState.sideBarIsVisible};
		});
	};

	render() {
		const {currentUser, language, currency, children} = this.props;
		const {sideBarIsVisible} = this.state;

		const sideBarMenu = [
			{icon: 'home', name: 'home', label: 'Home', value: '', link: "/"},
			// Only show "My Dashboard" / "Vendor dashboard" for Admin and Partner users
			...(currentUser.role && (currentUser.role === "Admin" || currentUser.role === "Vendor") 
				? [{icon: 'fas fa-columns', name: 'dashboard', label: currentUser.role === "Vendor" ? "Vendor dashboard" : "My Dashboard", value: '', link: roleBasedUrl(currentUser.role, "/")}]
				: []
			),
			{
				icon: 'book',
				name: 'my_bookings',
				label: 'My Bookings',
				value: '',
				link: '/bookings'
			},
			// {
			// 	icon: 'icon-user',
			// 	name: 'settings',
			// 	label: 'My Account',
			// 	details: currentUser.name,
			// 	value: '',
			// 	link: '/profile'
			// },
			// {
			// 	icon: 'fas fa-money-bill-alt',
			// 	name: 'currency',
			// 	label: 'Currency',
			// 	value: currency,
			// 	link: '/profile'
			// },
			// {
			// 	icon: 'icon-user',
			// 	name: 'settings',
			// 	label: 'Language',
			// 	details: '',
			// 	value: language,
			// 	link: '/profile'
			// },
			{
				icon: 'phone square',
				name: 'contact',
				label: 'Contact',
				value: '+977 981 961 5916',
				link: 'tel:+9779819615916'
			}
		];
		return (
			<div id='content'>
				<a href="#main-content" className="skip-link">
					Skip to main content
				</a>
				<NavBar sideBarIsVisible={sideBarIsVisible} toggleSidebar={() => this.toggleSidebar()} />
				<TouristPlanNav />
				{/* Hamburger sidebar - only for desktop/tablet fallback, hidden on mobile */}
				<Slidebar
					isVisible={this.state.sideBarIsVisible}
					items={sideBarMenu}
					side='left'
					onHide={() => this.toggleSidebar()}
					user={currentUser}
				/>
				<main id="main-content" role="main" tabIndex={-1}>
					{children}
				</main>
				{/* Bottom navigation - mobile only, replaces hamburger menu */}
				<BottomNav />
			</div>
		);
	}
}

const mapStateToProps = ({userStore, extras}) => ({
	currentUser: userStore.currentUser,
	language: extras.language
});

export default connect(mapStateToProps)(UserLayout);
